import { createContext, useContext } from "react";
import { type VariantProps } from "class-variance-authority";

import type { buttonVariants } from "../button/styles";

export type RadioGroupButtonVariant = NonNullable<VariantProps<typeof buttonVariants>["variant"]>;

interface RadioGroupButtonsContextValue {
  value: string | undefined;
  selectedVariant: RadioGroupButtonVariant;
  unselectedVariant: RadioGroupButtonVariant;
}

export const RadioGroupButtonsContext = createContext<RadioGroupButtonsContextValue>({
  value: undefined,
  selectedVariant: "secondary",
  unselectedVariant: "ghost",
});

export const useRadioGroupButtonsContext = () => useContext(RadioGroupButtonsContext);
